export default __webpack_public_path__ + "static/aerialaccess-f80ebcce9b62478e24b2a21123a8a3a6.png";